module.exports = __webpack_public_path__ + "img/ic_audit_report.d13e9ca0.svg";